module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lines_layer_on-d68ed31b15a9bdf378e3679ab297007e.jpg";